import { useMediaQuery, useTheme } from '@mui/material'

import { MobileSettings } from './mobile.component'

import { DesktopSettings } from './desktop.component'

export const AccountSettings = () => {
	const theme = useTheme()
	const isTablet = useMediaQuery(theme.breakpoints.down('tablet'))

	if (isTablet) {
		return <MobileSettings />
	}

	return <DesktopSettings />
}
